import { TwcOverlayTemplate } from "@/components/signup/layouts/product-overlay-template";
import { SignupBackgroundLayout } from "@/components/signup/layouts/signup-background-layout";
import { SiteActivation } from "@/components/signup/site-activation/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils/logos/teamwork-collection-logo";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import { Headings } from "../../components/headings";
import { FreeForTenUsersText } from "../../components/sub-heading";
import { WelcomeBackText } from "../../components/welcome-back-heading";

export const ExistingUser = () => {
    const twcSignupOverlayEnrolled = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );

    const content = (
        <>
            <Headings
                main={<WelcomeBackText />}
                sub={<FreeForTenUsersText />}
            />
            <SiteActivation />
        </>
    );

    if (twcSignupOverlayEnrolled) {
        return <TwcOverlayTemplate size="sm">{content}</TwcOverlayTemplate>;
    }

    return (
        <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
            {content}
        </SignupBackgroundLayout>
    );
};
